import { Minus, Plus } from "lucide-react";
import type { FC, Ref } from "react";
import { AmountStepperButton } from "web_myplann/Shared/Components/AmountStepperButton";
import { AmountStepperInput } from "web_myplann/Shared/Components/AmountStepperInput";
import { AmountStepperValue } from "web_myplann/Shared/Components/AmountStepperValue";
import { AMOUNT_STEPPER_HOLD } from "web_myplann/Shared/constants";
import { useSteppedValue } from "web_myplann/Shared/Hooks/useSteppedValue";
import type { AmountStepperSize } from "web_myplann/Shared/Types/AmountStepperSize";

type Props = {
	size: AmountStepperSize;
	value: number;
	onChange: (value: number) => void;
	step: number;
	readOnly?: boolean;
	valueColor?: string;
	inputId?: string;
	focusRef?: Ref<HTMLButtonElement>;
};

export const AmountStepper: FC<Props> = ({
	size,
	value,
	onChange,
	step,
	readOnly = false,
	valueColor,
	inputId,
	focusRef,
}) => {
	const {
		editing,
		startEditing,
		stopEditing,
		handleFieldChange,
		decrementHandlers,
		incrementHandlers,
		canDecrement,
		canIncrement,
	} = useSteppedValue({
		value,
		onChange,
		step,
		hold: AMOUNT_STEPPER_HOLD,
	});

	return (
		<>
			<AmountStepperButton
				size={size}
				icon={Minus}
				disabled={readOnly || !canDecrement}
				pressHandlers={decrementHandlers}
			/>
			{editing && !readOnly ? (
				<AmountStepperInput
					size={size}
					id={inputId}
					value={value}
					onChange={handleFieldChange}
					onDone={stopEditing}
				/>
			) : (
				<AmountStepperValue
					size={size}
					id={inputId}
					buttonRef={focusRef}
					value={value}
					color={valueColor}
					disabled={readOnly}
					onClick={startEditing}
				/>
			)}
			<AmountStepperButton
				size={size}
				icon={Plus}
				disabled={readOnly || !canIncrement}
				pressHandlers={incrementHandlers}
			/>
		</>
	);
};
